<template>
  <div class="container mx-auto flex flex-wrap w-screen">
    <div class="w-full flex">
      <label for="range" class="relative lg:mt-4 md:mt-0 mt-3 input-range-label mx-auto">
        <div class="relative directionLTR">
          <input
            id="range"
            type="range"
            name="range"
            :min="minPrice"
            :max="maxPrice"
            :step="step"
            :value="modelValue"
            @input="updateValue"
          />
          
          <div
            class="bg-primary-green absolute z-10 top-2 h-2.5 rounded-lg"
            :style="{ width: `${barWidth}%` }"
          ></div>
          <div class="absolute z-0 top-2 h-2.5 rounded-lg  w-full input-bg"></div>
        </div>

        <span class="dash top-2 left-2.5"></span>
        <span
          v-for="n in difference"
          :key="n"
          class="dash top-2"
          :style="{ left: leftDifference * n + 'px' }"
        ></span>
      </label>
    </div>
    <div class="w-full flex">
      <div class="input-range-label relative mx-auto w-full lg:pb-6">
        <span v-if="currentSelectedLanguage.short === 'ar'" class="absolute font-roboto text-xs sm:text-base left-1.5">{{ minPrice.toString().toArabicDigits() }}</span>
        <span v-else class="absolute font-roboto text-xs sm:text-base left-1.5">{{ minPrice }}</span>
      <span v-if="currentSelectedLanguage.short === 'ar'">
        <span
          v-for="n in difference"
          :key="n"
          :style="getStyle(n)"
          class="absolute font-roboto text-xs sm:text-base"
        >
          {{ (n === difference ? maxPrice : getExactNumber(n)).toString().toArabicDigits() }}
        </span>
        </span>
      <span v-else>
        <span
          v-for="n in difference"
          :key="n"
          :style="getStyle(n)"
          class="absolute font-roboto text-xs sm:text-base "
        >
          {{ n === difference ? maxPrice : getExactNumber(n) }}
        </span>
        </span>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { mapState } from 'vuex'
export default {
  page: {
    title: 'Home',
  },
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    step: {
      type: [String, Number],
      default: 1,
    },
    minPrice: {
      type: [String, Number],
      default: 1,
    },
    maxPrice: {
      type: [String, Number],
      default: 3000,
    },
    difference: {
      type: [String, Number],
      default: 6,
    },
  },
  data() {
    return {
      showDemoModal: false,
      landingPage: 'landingPage',
      leftDifference: 0,
      countDifference: 0,
      pricePaddingDifference: 0,
      rangeValue: 1,
      barWidth: 0,
    }
  },
  computed: {
    ...mapState(['currentSelectedLanguage']),
  },
  watch: {
    rangeValue: {
      handler(value) {
        if (value <= this.maxPrice) this.barWidth = (value * 100) / this.maxPrice
        else this.barWidth = 100
      },
    },
    modelValue: {
      handler(value) {
        this.rangeValue = value
        // if (currentSelectedLanguage.short === 'ar') this.rangeValue = value.toString().toArabicDigits()
        // else this.rangeValue = value
      },
    },
  },
  created() {
    let browserWidth = document.body.clientWidth
    let width = 0
    if (browserWidth < 768) {
      width = 306
    } else if (browserWidth < 1024) {
      width = 620
    } else {
      width = 640
    }
    this.countDifference = (this.maxPrice - this.minPrice) / this.difference
    this.leftDifference = Math.abs(width / this.difference - 1) // 1 because loop started from
  },
  methods: {
    goToPricingDetails() {
      if (this.currency === 'PKR') {
        this.$router.push({ name: 'pricing-details' })
      } else {
        this.$router.push({ name: 'pricing-details' })
      }
    },
    getExactNumber(n) {
      let returnVal = Math.floor(this.minPrice + this.countDifference * n)
      return returnVal
    },
    getStyle(n) {
      let diff = 0
      let val = this.minPrice + this.countDifference * n
      if (val < 10) {
        diff = -3
      } else if (val < 100) {
        diff = -8
      } else if (val < 1000) {
        diff = -10
      } else {
        diff = -20
      }

      return { left: this.leftDifference * n + diff + 'px' }
    },
    updateValue(event) {
      this.rangeValue = event.target.value
      this.$emit('update:modelValue', event.target.value)
    },
  },
}
</script>
  
<style lang="scss" scoped>
.input-range-label {
  max-width: 316px;
}

input[type='range'] {
  -webkit-appearance: none;
  background-color: transparent;
  width: 316px;
  height: 26px;
  overflow: hidden;
  transform-origin: 50% 50% 300px;
}
input[type='range']:focus {
  outline: none;
}
input[type='range']::-webkit-slider-thumb {
  position: relative;
  -webkit-appearance: none;
  cursor: pointer;
  background-color: #09814a;
  border-radius: 999999px;
  width: 26px;
  height: 26px;
  z-index: 88;
 
}
input[type='range']:before {
  content: '';
  position: absolute;
  background: #e8f3ed;
  box-shadow: 0 1px 0 rgb(235, 235, 235);
  width: 316px;
  left: 1px;
  height: 10px;
  top: 8px;
  border-radius: 20px;
  z-index: 30;
  opacity: 0;
}
input[type='range']:after {
  content: '';
  position: absolute;
  background: #090a0a;
}
.input-bg{
  background: #e8f3ed;
  box-shadow: 0 1px 0 rgb(235, 235, 235);
}
.dash {
  position: absolute;
  background: #87d2a9;
  width: 1px;
  left: 10px;
  border-radius: 50%;
  z-index: 30;
  height: 10px;
}

@media only screen and (min-width: 768px) {
  .input-range-label {
    max-width: 630px;
  }
  input[type='range'] {
    width: 630px;
  }
  input[type='range']:before {
    width: 630px;
  }
}
@media only screen and (min-width: 1024px) {
  .input-range-label {
    max-width: 650px;
  }
  input[type='range'] {
    width: 650px;
  }
  input[type='range']:before {
    width: 650px;
  }
}
.directionLTR{
  direction: ltr;
}
</style>
  